// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5fb577f8","667":"0168a1e6","977":"6fa7e9b9"}[chunkId] + ".chunk.js";
};